import { useLanguage } from "../languageContext";
import translations from "../translation.json";
import HeaderNavButtons from "./Common/headerNavButtons";

const EventViewHeader = ({
  eventId,
  dealershipDetails,
  isDarkMode,
  setDisplayComponent,
  title,
  activePage,
  showStatusReport = false,
  children,
}) => {
  const { language } = useLanguage();

  return (
    <div className="row align-items-start justify-content-between flex-shrink-0 gy-2 pb-4">
      <div className="col-12 col-lg-6" style={{ minWidth: 0 }}>
        <h2
          id="h1"
          className={`${isDarkMode ? "darkthead" : ""} text-wrap mb-0`}
          style={{ overflowWrap: "anywhere" }}
        >
          {title ?? translations.eventView.buttons.dashboard[language]}
          {" - "}{dealershipDetails?.name}{": "}
          {dealershipDetails?.start_date}{" "}
          {translations.commonWords.to[language]}{" "}
          {dealershipDetails?.end_date}
        </h2>
      </div>
      <div className="col-12 col-lg-6 d-flex flex-column gap-2">
        <HeaderNavButtons
          eventId={eventId}
          setDisplayComponent={setDisplayComponent}
          activePage={activePage}
          showStatusReport={showStatusReport}
        />
        {children && (
          <div className="gap-1 d-flex flex-wrap align-items-center justify-content-end">
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default EventViewHeader;
